import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, programManagementURL } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { GET_PROGRAM_FILTER_CONFIGS, GET_PROGRAM_FILTER_CONFIGS_ERROR, GET_PROGRAM_FILTER_CONFIGS_SUCCESS } from '../../actions.js';

function* getProgramFilterConfigs({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/v1/filter-config`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_PROGRAM_FILTER_CONFIGS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_PROGRAM_FILTER_CONFIGS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_PROGRAM_FILTER_CONFIGS_ERROR, payload: error });
  }
}

export function* watchGetProgramFilterConfigs() {
  yield takeEvery(GET_PROGRAM_FILTER_CONFIGS, getProgramFilterConfigs);
}

function* getProgramFilterConfigsSaga() {
  yield all([fork(watchGetProgramFilterConfigs)]);
}

export default getProgramFilterConfigsSaga;
